module.exports = __webpack_public_path__ + "static/media/buildsummary_icon_wishlist.c5a9ae71.svg";